import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import "./Tab.css";

import { useState } from "react";

import FirstTab from "../FirstTab/FirstTab";
import SecondTab from "../SecondTab/SecondTab";
import ThirdTabMain from "../ThirdTab/ThirdTabMain";
import FourthTab from "../FourthTab/FourthTab";
import PostedJobs from "../PostedJobs/PostedJobs";
import AppliedPortfolio from "../../../JobseekerPage/DashBoardJob/AppliedPortfolio/AppliedPortfolio";

// Recruiter Dashboard Stages
const stages = [
  {
    title: "Pool History",
    caption: "Track pooled candidates",
  },
  {
    title: "Manage Jobs",
    caption: "Create & edit jobs",
  },
  {
    title: "Applied Portfolios",
    caption: "Review applications",
  },
  {
    title: "Matched Portfolios",
    caption: "Best candidate matches",
  },
  {
    title: "Portfolios",
    caption: "Browse all portfolios",
  },
];

// Tab Heading Component
const StageTab = ({ title, caption }) => (
  <div className="stage-tab">
    <span className="stage-title">{title}</span>
    <span className="stage-caption">{caption}</span>
  </div>
);

const MainTab = () => {
  const [active, setActive] = useState(0);

  return (
    <section className="main-tabs">
      <div className="container-fluid p-0">
        <div className="main-design-tab">
          <Tabs
            selectedIndex={active}
            onSelect={(index) => setActive(index)}
          >
            <div className="container">
              <TabList className="job-tabs-list">
                {stages.map((stage) => (
                  <Tab key={stage.title}>
                    <StageTab
                      title={stage.title}
                      caption={stage.caption}
                    />
                  </Tab>
                ))}
              </TabList>
            </div>

            {/* Pool History */}
            <TabPanel>
              <FirstTab />
              <PostedJobs />
            </TabPanel>

            {/* Manage Jobs */}
            <TabPanel>
              <SecondTab />
            </TabPanel>

            {/* Applied Portfolios */}
            <TabPanel>
              <AppliedPortfolio />
            </TabPanel>

            {/* Matched Portfolios */}
            <TabPanel>
              <ThirdTabMain />
            </TabPanel>

            {/* Portfolios */}
            <TabPanel>
              <FourthTab />
            </TabPanel>
          </Tabs>
        </div>
      </div>
    </section>
  );
};

export default MainTab;